import {Component} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'ngx-merchant-selection-util',
  templateUrl: './merchant-selection-util.component.html',
  styleUrls: ['./merchant-selection-util.component.scss'],
})
export class MerchantSelectionUtilComponent {
  toppings = new FormControl('');
  toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];
}
